import GatsbyImage from 'gatsby-image';
import PropTypes from 'prop-types';
import * as React from 'react';

const FooterImage = ({ fluid, objectPosition = 'top', alt }) => {
  if (!fluid) return null;
  return (
    <GatsbyImage
      fluid={fluid}
      style={{ minHeight: '45rem', maxHeight: `45rem` }}
      imgStyle={{ objectPosition }}
      alt={alt}
    />
  );
};

FooterImage.propTypes = {
  fluid: PropTypes.object.isRequired,
  objectPosition: PropTypes.string,
  alt: PropTypes.string,
};

export { FooterImage };
